<template>
  <div
    class="page max-w-[1010px]"
    data-test="page"
  >
    <div
      class="header"
      data-test="header"
    >
      Settings and Users
    </div>
    <div
      class="flex flex-row gap-8 account-card-container"
      data-test="account-card-container"
    >
      <div
        class="flex-1"
        data-test="company-info-card"
      >
        <CompanyInfoCard class="account-card" />
      </div>

      <div
        class="flex-1"
        data-test="account-info-card"
      >
        <AccountInfoCard class="account-card" />
      </div>
    </div>
    <div
      class="flex flex-row gap-8 mt-8"
      data-test="company-users-container"
    >
      <div
        class="flex-1"
        data-test="company-users"
      >
        <CompanyUsers />
      </div>
    </div>
  </div>
</template>

<script setup>
import AccountInfoCard from '@/pages/donorAccount/settings/components/AccountInfoCard.vue';
import CompanyInfoCard from '@/components/companyGiving/CompanyInfoCard.vue';
import { ref, onBeforeMount } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useCompanyAdminStore } from '../../../stores/CompanyAdminStore';
import { useToastStore } from '@/stores/ToastStore.js';
import getContrastYIQ from '@/helpers/getContrastYIQ';
import MediaForm from '../../../components/companyGiving/MediaForm.vue';
import AboutUsForm from '../../../components/companyGiving/AboutUsForm.vue';
import FeaturedCausesForm from '../../../components/companyGiving/FeaturedCausesForm.vue';
import GivesDayForm from '../../../components/companyGiving/GivesDayForm.vue';
import filters from '@/helpers/filters.js';
import Pencil from '@/assets/Pencil.vue';
import Eye from '@/assets/Eye.vue';
import CompanyUsers from '@/components/companyGiving/CompanyUsers.vue';

const formatMoney = filters.formatMoney;

const donorStore = useDonorStore();
const companyAdminStore = useCompanyAdminStore();

const mainColor = donorStore.mainColor;

const editStates = ref({
  aboutUs: false,
  givesDayInfo: false,
  media: false,
});

const isSavingStates = ref({
  aboutUs: false,
  givesDayInfo: false,
  media: false,
});

const cancelChanges = (section) => {
  editStates.value[section] = false;
};

const saveChanges = async (section, forms) => {
  isSavingStates.value[section] = true;
  try {
    await companyAdminStore.saveForm([...forms, { status: 6434 }]);

    useToastStore().add({
      severity: 'success',
      summary: `${section.charAt(0).toUpperCase() + section.slice(1)} Updated`,
      detail: `Your ${section} has been updated successfully.`,
      life: 3000,
    });

    editStates.value[section] = false;
  } catch (e) {
    useToastStore().add({
      severity: 'error',
      summary: 'Error',
      detail: e.message,
      life: 3000,
    });
  } finally {
    isSavingStates.value[section] = false;
  }
};

const viewPage = () => {
  window.location.href = donorStore.domain + '/company/' + companyAdminStore.company.customUrl;
};

onBeforeMount(async () => {
  await companyAdminStore.getCompany();
});
</script>

<style scoped>
.card-style {
  display: flex;
  width: 100%;
  max-width: 930px;
  margin-bottom: 42px;
}
.char-count {
  color: var(--purple-400, #54698d);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px; /* 125% */
}
.footer-buttons {
  display: flex;
  justify-content: space-between;
}
.styled-text {
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
label {
  font-size: 12px;
}
.about-us-title,
.gives-day-info-title {
  font-size: 20px;
}
.styled-textarea {
  width: 430px;
  height: 171px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid var(--White, #fff);
  background: var(--White, #fff);
  border-color: v-bind('donorStore.mainColor');
}
.styled-input {
  width: 288px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid var(--White, #fff);
  background: var(--White, #fff);
  border-color: v-bind('donorStore.mainColor');
}
.about-us-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  max-width: 329px;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
}

.media-images {
  width: 254px;
  height: 147px;
  margin-bottom: 24px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.left-column {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex-shrink: 0;
}
.right-column {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex-shrink: 0;
}
.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 24px;
}
.flex-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.image-loader-container {
  display: flex;
  justify-content: space-between;
  gap: 24px;
}
@media (min-width: 768px) {
  .left-column {
    width: 430px;
  }
  .right-column {
    width: 329px;
    flex-direction: row;
  }
  .flex-container {
    flex-direction: row;
  }
}

@media (max-width: 767px) {
  .page {
    padding: 0 24px;
  }
}
</style>
